import React from 'react';

const SeverityAssessment = ({ value, onChange }) => {
  const severityLevels = [
    { value: 'low', label: 'Low', color: 'bg-green-500', description: 'Minor concern, no immediate risk' },
    { value: 'medium', label: 'Medium', color: 'bg-yellow-500', description: 'Moderate risk, requires attention' },
    { value: 'high', label: 'High', color: 'bg-orange-500', description: 'Significant risk, prompt action needed' },
    { value: 'critical', label: 'Critical', color: 'bg-red-500', description: 'Immediate danger, urgent action required' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Severity Assessment</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {severityLevels?.map((level) => (
          <button
            key={level?.value}
            type="button"
            onClick={() => onChange(level?.value)}
            className={`p-4 rounded-lg border-2 transition-all ${
              value === level?.value
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
            }`}
          >
            <div className={`w-full h-2 ${level?.color} rounded-full mb-3`}></div>
            <h4 className="font-medium text-foreground mb-1">{level?.label}</h4>
            <p className="text-xs text-muted-foreground">{level?.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SeverityAssessment;